$(document).ready(function () {

    if($('#santa').length) {

        const santaClosed = $('.santa__closed');
        const santaOpened = $('.santa__opened');

        $('#santa').on('click', function () {

            if(santaClosed.hasClass('active')) {
                $(this).find(santaClosed).removeClass('firstClick');
                $(this).find(santaClosed).removeClass('active');
                $(this).find(santaOpened).addClass('active');
            } else {
                $(this).find(santaOpened).removeClass('active');
                $(this).find(santaClosed).addClass('active');
            }

        });
    }

    // $('.infoBox__close').on('click', function () {
    //     $(this).closest('.infoBox').hide();
    // });
    //
    // // проверка если куки уже есть
    // if (document.cookie.split(';').filter((item) => item.trim().startsWith('infoBoxMindbox=')).length) {
    //     // если куки есть скрыть инфобокс
    //     document.querySelector('#infoBox').style.display = "none";
    // } else {
    //     // если куки нет показать инфобокс
    //     document.querySelector('#infoBox').style.display = "flex";
    // }
});

/*Создаем и сохраняем cookie на время сессии*/
/*function setCookie() {
    document.cookie = "infoBoxMindbox=informed";
}*/
